import {
  NotificationApi,
  NotificationApiResponse,
} from '../../api/Notifications';
import { Group } from '../models/Group';
import { Notification } from '../models/Notification';
import { makeAutoObservable } from 'mobx';

export class NotificationStore {
  groupNotifications: Map<number, Notification[]> = new Map();

  constructor() {
    makeAutoObservable(this);
  }

  getGroupNotifications = (group: Group): Notification[] => {
    if (group && this.groupNotifications.has(group.id)) {
      return this.groupNotifications.get(group.id);
    }
    return null;
  };

  editUnreadStatus = (group: Group, notification: Notification): void => {
    NotificationApi.editUnreadStatus(group.id, notification.id).then(
      (updatedNotification: NotificationApiResponse) => {
        notification.unread = updatedNotification.unread;
      }
    );
  };

  loadGroupNotifications = (group: Group): Promise<Notification[]> => {
    return NotificationApi.getGroupNotifications(group.id).then(
      (notifications: NotificationApiResponse[]) => {
        const notificationObjects = notifications.map(apiNotification =>
          Notification.fromApi(apiNotification)
        );
        this.groupNotifications.set(group.id, notificationObjects);
        return notificationObjects;
      }
    );
  };
}
